import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AlertsConfiguration } from '../../types/Devices';
import { getGlobalAlertSettingsByFleetId } from '../../services/DeviceService';

function useGetGlobalAlertSettingsByFleetId(fleetId: string, alertName: string): UseQueryResult<AlertsConfiguration> {
  return useQuery(
    ['device-global-alerts-settings', fleetId, alertName],
    async (): Promise<AlertsConfiguration> => getGlobalAlertSettingsByFleetId(fleetId, alertName),
    {
      retry: 0,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!fleetId,
    },
  );
}

export default useGetGlobalAlertSettingsByFleetId;
